module.exports = __webpack_public_path__ + "img/0Q3A4053_L_Wood.257dc490.jpg";